import React from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import Config from '../config'
import WKOwnDialog from '../components/wk/WKOwnDialog'
import DeepFocusDialog from '../components/details/DeepFocusDialog'
import ShareSuccessPage from '../components/details/ShareSuccessPage'

var JSAPI_LIST = [
    'onMenuShareTimeline',
    'onMenuShareAppMessage',
    'onMenuShareQQ',
    'onMenuShareWeibo',
    'onMenuShareQZone',
    'startRecord',
    'stopRecord',
    'onVoiceRecordEnd',
    'playVoice',
    'pauseVoice',
    'stopVoice',
    'onVoicePlayEnd',
    'uploadVoice',
    'downloadVoice',
    'chooseImage',
    'previewImage',
    'uploadImage',
    'downloadImage',
    'translateVoice',
    'getNetworkType',
    'openLocation',
    'getLocation',
    'hideOptionMenu',
    'showOptionMenu',
    'hideMenuItems',
    'showMenuItems',
    'hideAllNonBaseMenuItem',
    'showAllNonBaseMenuItem',
    'closeWindow',
    'scanQRCode',
    'chooseWXPay',
    'openProductSpecificView',
    'addCard',
    'chooseCard',
    'openCard',
    'launch3rdApp',
]

class WeixinApi extends React.PureComponent {
    jssdkUrl = null;

    constructor(props) {
        super(props)
        this.state = {
            isShowGroupNoLimitDialog: false
        }
    }

    initJSSDK() {
        if(this.jssdkUrl === window.location.href)
            return
        this.jssdkUrl = window.location.href
        if((window.platform === 'weixin' || /WindowsWechat/.test(navigator.userAgent)) && !this.jssdkLoading){
            const params = {
                url: this.jssdkUrl,
                appid: Config.WXAPPID,
                debug: 0
            }
            this.jssdkLoading = true
            axios.get('/api/weixin/jssdk_config', {params: params}).then((response) => {
                if(window.wx && response.data){
                    let config = response.data.data
                    config.appId = params.appid
                    config.jsApiList = JSAPI_LIST
                    config.debug = false
                    window.wx.config(config)
                    window.wx.ready(()=>{
                        this.jssdkLoading = false
                        window.wxReady = true
                        this.props.dispatch({
                            type: 'WECHAT_SET_READY'
                        })
                        window.wx.onVoiceRecordEnd({
                            // 录音时间超过一分钟没有停止的时候，中途录音中断都会执行 complete 回调
                            complete: (res) => {
                                if (this.props.recordDuration < 58 && window.systemType === 'ios') {
                                    this.props.dispatch({type: 'RECORDER_CANCEL_RECORD'})
                                    this.setState({ isShowGroupNoLimitDialog: true })
                                } else {
                                    this.props.dispatch({  
                                        type: 'RECORDER_FORCE_STOP',
                                        payload: {
                                            localId: res.localId
                                        }
                                    });
                                }
                            }
                        })
                        window.wx.onVoicePlayEnd({
                            complete: (res) => {
                                this.props.dispatch({
                                    type: 'AUDIO_STOPPED',
                                    payload: {
                                        localId: res.localId
                                    }
                                });
                            }
                        })

                        // 微信端自动播放
                        const {audioPlayer} = this.props
                        if(audioPlayer.audioState === 'load'){
                            const audio = document.getElementById('player_audio')
                            if(audio.src && audio.paused){
                                audio.load()
                            }
                        }else{
                            // 录播音频自动播放
                            const player = document.getElementById('wk_audio_player')
                            if(player && player.paused){
                                player.play()
                            }else{
                                if(audioPlayer.audioState === 'stopped'){
                                    this.props.dispatch({
                                        type: 'AUDIO_LOAD',
                                        payload: {
                                            dataUrl: 'data:audio/mpeg;base64,//FsgAPf/N4CAExhdmM1Ny4zOC4xMDAAQiAIwRg4//FsgAG//CEQBGCMHA=='
                                        }
                                    })
                                }
                            }
                        }
                    })
                }
            })
        }

    }


    componentDidMount(){
        const {wechat} = this.props
        if(!wechat.ready){
            this.initJSSDK()
        }
    }

    componentDidUpdate(){
        const {wechat, account} = this.props
        const {dispatch} = this.props
        if(wechat.ready && wechat.shareData){
            let title = wechat.shareData.title ? wechat.shareData.title.replace(/<\/?[^>]+(>|$)/g, "") : '';
            let desc = wechat.shareData.desc ? wechat.shareData.desc.replace(/<\/?[^>]+(>|$)/g, "") : '';
            if(desc.length === 0 && account.nickname){
                desc = `${account.nickname}向你推荐`
            }
            window.wx.onMenuShareAppMessage({
                title: title,
                desc: desc,
                link: wechat.shareData.link,
                imgUrl: wechat.shareData.imgUrl,
                type: wechat.shareData.type,
                dataUrl: wechat.shareData.dataUrl,
                success: () => {

                    if (!this.props.account.subscribed){
                        this.props.dispatch({
                            type: 'DEEP_FOCUS_DIALOG_SHOW'
                        });
                    }else {
                        this.props.dispatch({
                            type: 'DEEP_SHARE_DIALOG_SHOW'
                        });
                    }

                    if (wechat.shareData.successCallback){
                        wechat.shareData.successCallback()
                    }

                    if (wechat.shareData.objectType.search(/(lecture)|(liveroom)|(channel)|(classroom)/)>-1) {
                        dispatch({
                            type: "STATS_LOG",
                            payload: {
                                action: 'share_app_message',
                                ts: new Date().getTime(),
                                obj_type: wechat.shareData.objectType,
                                obj_id: wechat.shareData.objectId,
                                obj_meta: wechat.shareData.objectMeta,
                                account_id: account.id,
                            }
                        })
                    }
                },

            });
            window.wx.onMenuShareTimeline({
                title: title,
                link: 'https://share.lizhiweike.com?redirect_url=' + encodeURIComponent(wechat.shareData.link),
                imgUrl: wechat.shareData.imgUrl,
                success: () => {

                    if (!this.props.account.subscribed){
                        this.props.dispatch({
                            type: 'DEEP_FOCUS_DIALOG_SHOW'
                        });
                    }else {
                        this.props.dispatch({
                            type: 'DEEP_SHARE_DIALOG_SHOW'
                        });
                    }

                    if (wechat.shareData.successCallback){
                        wechat.shareData.successCallback()
                    }

                    if (wechat.shareData.objectType.search(/(lecture)|(liveroom)|(channel)|(classroom)/) > -1) {
                        dispatch({
                            type: "STATS_LOG",
                            payload: {
                                action: 'share_timeline',
                                ts: new Date().getTime(),
                                obj_type: wechat.shareData.objectType,
                                obj_id: wechat.shareData.objectId,
                                obj_meta: wechat.shareData.objectMeta,
                                account_id: account.id,
                            }
                        })
                    }
                }
            });
        }

        if(!wechat.ready){
            this.initJSSDK()
        }
    }

    getInitComponent () {
        return (
            <div>
                <WKOwnDialog type="ios" title='' buttons={[
                    { label: '知道了', onClick: () => this.setState({ isShowGroupNoLimitDialog: false }) }
                ]} show={this.state.isShowGroupNoLimitDialog}>
                    微信自动结束录音
                </WKOwnDialog>
            </div>
        )
    }
    
    render() {
        if (/sharecard/.test(window.location.pathname)){
            return this.getInitComponent()
        }

        const {wechat} = this.props

        if (wechat.shareData && wechat.shareData.liveroom_id && wechat.shareData.liveroom_id === 23697056) {
            return this.getInitComponent()
        }

        if (!this.props.account.subscribed) {
            return (
                <div>
                    {this.getInitComponent()}
                    {this.props.details.showFocusDialog &&
                    <DeepFocusDialog isResell={wechat.shareData && wechat.shareData.is_resell}/>
                    }
                </div>
            )
        }

        if (this.props.account.subscribed && /lecture|channel/.test(window.location.pathname) && !this.props.account.has_liveroom) {
            return (
                <div>
                    {this.getInitComponent()}
                    {this.props.details.showShareDialog &&
                    <ShareSuccessPage />
                    }
                </div>
            );
        }

        return (
            <div>
                {this.getInitComponent()}
            </div>
        )
    }
}


export default connect((state) => ({
    wechat: state.wechat,
    account: state.account,
    audioPlayer: state.audioPlayer,
    recordDuration: state.audioRecorder.recordDuration,
    details: state.details,
}))(WeixinApi)




// WEBPACK FOOTER //
// ./src/components/WeixinApi.js